import React, { useEffect, useState } from 'react';
import { documentTagServices } from '../../../APIServices/documentTagServices';
import Pagination from '../../../hooks/Pagination';
import AddNewDocumentTag from './AddNewDocumentTag';
import UpdateDocumentTag from './UpdateDocumentTag';
import DeleteDocumentTag from './DeleteDocumentTag';
import DeletedDocumentTagHistory from './DeletedDocumentTagHistory';

function DocumentTagManagement() {
  const [documentTagList, setDocumentTagList] = useState([]);
  const [documentTagCount, setDocumentTagCount] = useState(0);
  const [deleteDocumentTagList, setDeleteDocumentTagList] = useState([]);
  const [deleteDocumentTagCount, setDeleteDocumentTagCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [documentTagData, setDocumentTagData] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPage = Math.ceil(documentTagCount / itemsPerPage);
  const [deletedPageNumber, setDeletedPageNumber] = useState(1);
  const [deletedItemsPerPage, setDeletedItemsPerPage] = useState(10);

  const getDocumentTagData = async () => {
    setLoading(true);
    const data = await documentTagServices.getDocumentTagData('active', '', pageNumber, itemsPerPage);
    setDocumentTagList(data?.data || []);
    setDocumentTagCount(data?.count || 0);
    setLoading(false);
  };

  const getDeletedDocumentTagData = async () => {
    setLoading(true);
    const data = await documentTagServices.getDocumentTagData('deleted', '', deletedPageNumber, deletedItemsPerPage);
    setDeleteDocumentTagList(data?.data || []);
    setDeleteDocumentTagCount(data?.count || 0);
    setLoading(false);
  };

  useEffect(() => {
    getDocumentTagData();
  }, [pageNumber, itemsPerPage]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Workspace metadata</div>
          <h1 className="page-title">Document Tag Management</h1>
          <p className="page-sub">
            Create, update, and manage document tags used across workspace metadata and document classification.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Document Tags <span className="count">{documentTagCount}</span>
        </div>

        <div className="hstack gap-4">
          <button className="btn btn-primary" onClick={() => setModalOpen('add')}>
            <i className="ti ti-plus" />
            Add Document Tag
          </button>
          <button className="btn btn-danger" onClick={() => setModalOpen('deletedHistiory')}>
            <i className="ti ti-history" />
            Deleted History
          </button>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <div className="buttonLoader" />
            <div style={{ marginTop: 12 }}>Loading document tags...</div>
          </div>
        ) : documentTagCount === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: 'var(--ink-3)' }}>
            <i className="ti ti-tags" style={{ fontSize: 24, display: 'block', marginBottom: 8 }} />
            No Document Tag. Click "Add Document Tag" to create one.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>Document Tag</th>
                  <th style={{ width: 120 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documentTagList.map((item) => (
                  <tr key={item._id}>
                    <td className="medium">{item.documentTag}</td>
                    <td>
                      <div className="flex gap-2">
                        <button
                          className="icon-btn"
                          title="Edit"
                          style={{ color: 'var(--info)' }}
                          onClick={() => {
                            setModalOpen('update');
                            setDocumentTagData(item);
                          }}
                        >
                          <i className="ti ti-edit" />
                        </button>
                        <button
                          className="icon-btn"
                          title="Delete"
                          style={{ color: 'var(--danger)' }}
                          onClick={() => {
                            setModalOpen('delete');
                            setDocumentTagData(item);
                          }}
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Pagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalPage={totalPage}
              totalItems={documentTagCount}
            />
          </>
        )}
      </div>

      {modalOpen === 'add' && (
        <AddNewDocumentTag setModalOpen={setModalOpen} getDocumentTagData={getDocumentTagData} />
      )}
      {modalOpen === 'update' && (
        <UpdateDocumentTag
          documentTagData={documentTagData}
          setModalOpen={setModalOpen}
          getDocumentTagData={getDocumentTagData}
          setConfirm={setConfirm}
          confirm={confirm}
        />
      )}
      {modalOpen === 'delete' && (
        <DeleteDocumentTag
          getDocumentTagData={getDocumentTagData}
          getDeletedDocumentTagData={getDeletedDocumentTagData}
          setModalOpen={setModalOpen}
          documentTagData={documentTagData}
        />
      )}
      {modalOpen === 'deletedHistiory' && (
        <DeletedDocumentTagHistory
          getDocumentTagData={getDocumentTagData}
          getDeletedDocumentTagData={getDeletedDocumentTagData}
          setModalOpen={setModalOpen}
          deletedPageNumber={deletedPageNumber}
          setDeletedPageNumber={setDeletedPageNumber}
          deletedItemsPerPage={deletedItemsPerPage}
          setDeletedItemsPerPage={setDeletedItemsPerPage}
          deleteDocumentTagList={deleteDocumentTagList}
          deleteDocumentTagCount={deleteDocumentTagCount}
        />
      )}

    </div>
  );
}

export default DocumentTagManagement;